<template lang="pug">
  .div
    .dialog-container(v-if='!newEmptyPlaylist', id="DialogPlayListCreate-nonEmptyContainer")
      h4 {{$t('Create')}}&nbsp;{{ choice === 'PlayList' ? $t('Playlist') : $t('Layout')}}
        span &nbsp;
        font-awesome-icon(v-if="choice === 'PlayList'", icon="film")
        font-awesome-icon(v-else, icon="layer-group")
      hr.header
      el-row
        el-col.col-left(:span="10")
          h4 {{$t('Media Assigned')}}:
          hr.header
          ShortMediaList(id="DialogPlayListCreate-mediaList" ref='childrenList', :items='this.$store.state.Medium.media_selected_left', :showThumbs="true", :showMediaIcons="true")
        el-col.col-middle(:span="4")
          el-button.confirm(id="DialogPlayListCreate-createButton" v-if='!saving', type="success", :disabled='!newPlayListHasName', @click="createPlayListWithMedia()", circle)
            font-awesome-icon.linker-icon(icon="film")
            | &nbsp; {{$t("Create")}} &nbsp;
          el-button.confirm.spinner(v-if='saving', type="primary", circle)
            font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
            .spinner-text {{ percentDone }}%
        el-col.col-right(:span="10")
          .playlist
            h4 {{ choice === 'PlayList' ? $t('Playlist') : $t('Layout')}}:
            hr.header
            //- el-form(v-on:submit.native.prevent='createPlayListWithMedia()')
            //- el-form-item(:label="$t('Name')")
            //- el-form-item(v-if='choice === "PlayListLayout"', :label="$t('Width')")
            .form
              .form-item
                el-input(id="DialogPlayListCreate-nameInput" v-model="playlistName", @keyup.enter.native='createPlayListWithMedia()', ref="input_name", type="text", :placeholder="$t(choice === 'PlayList' ? $t('Playlist name') : $t('Layout name'))")
              .form-item(v-if='choice === "PlayListLayout"')
                .label {{$t('Width')}}
                el-input-number(id="DialogPlayListCreate-widthInput" v-model="layoutData.playListLayoutWidth", @keyup.enter.native='createPlayListWithMedia()', type="text", placeholder="Width px")
                .suffix px
              .form-item(v-if='choice === "PlayListLayout"')
                .label {{$t('Height')}}
                el-input-number(id="DialogPlayListCreate-heightInput" v-model="layoutData.playListLayoutHeight", @keyup.enter.native='createPlayListWithMedia()', type="text", placeholder="Height px")
                .suffix px
            //- el-form-item(v-if='choice === "PlayListLayout"', :label="$t('Height')")
    .dialog-container(v-if='newEmptyPlaylist' id="DialogPlayListCreate-emptyContainer")
      h4 {{$t('Create')}}&nbsp;{{ choice === 'PlayList' ? $t('Playlist') : $t('Layout')}}
        span &nbsp;
        font-awesome-icon(v-if="choice === 'PlayList'", icon="film")
        font-awesome-icon(v-else, icon="layer-group")
      hr.header
      .form
        .playlist
          el-form(
            label-width="120px",
            v-on:submit.native.prevent="createPlayListWithMedia()"
          )
            el-form-item(:label="$t('Name')")
              el-input(
                ref="input_name",
                v-model="playlistName",
                type="text",
                size="mini",
                id="DialogPlayListCreate-emptyNameInput",
                :placeholder="$t(choice === 'PlayList' ? $t('Playlist name') : $t('Layout name'))"
              )
            el-form-item(v-if='choice === "PlayListLayout"', :label="$t('Width')")
              el-input-number(id="DialogPlayListCreate-emptyWidthInput" v-model="layoutData.playListLayoutWidth", size="mini", type="text", placeholder="Width px")
            el-form-item(v-if='choice === "PlayListLayout"', :label="$t('Height')")
              el-input-number(id="DialogPlayListCreate-emptyHeightInput" v-model="layoutData.playListLayoutHeight", size="mini", type="text", placeholder="Height px")
        .button.float-right
          el-button(id="DialogPlayListCreate-submitEmptyButton" type="success", size="mini", :disabled='!newPlayListHasName || saving', @click="createPlayListWithMedia()")
            font-awesome-icon.linker-icon(icon="film")
            | &nbsp; {{ !saving ? $t("Create") : $t("saving...")}} &nbsp;
      br
      br
    p.error(v-if='error') {{ error }}
</template>

<script>
import Vue from 'vue'
import ShortMediaList from '../Common/ShortMediaList'

export default {
  props: ['choice'],
  components: {
    ShortMediaList
  },
  mounted () {
    if (this.$refs.input_name) this.$refs.input_name.focus()
  },
  data () {
    return {
      error: undefined,
      saving: false,
      percentDone: 0,
      playlistName: '',
      layoutData: {
        playListLayoutWidth: 1920,
        playListLayoutHeight: 1080,
        type: 'PlayListLayout'
      }
    }
  },
  methods: {
    async createPlayListWithMedia () {
      this.$emit('linkerJobStarted')
      if (this.playlistName.length === 0) return
      this.saving = true
      let children = []
      if (!this.newEmptyPlaylist) {
        children = JSON.parse(JSON.stringify(this.$refs.childrenList.selectedItems))
      }
      const toBeDoneOperations = children.length
      let doneSoFarOperations = 0

      const params = {
        where: {
          type: {
            contains: 'PlayList'
          },
          name: this.playlistName
        }
      }
      const mediumWithNameFound = (await Vue.axios.get(`medium`, { params })).data.filter(medium => !medium.type.includes('Library'))
      if (mediumWithNameFound.length > 0) {
        this.error = 'Medium with that name already exists.'
        this.saving = false
        return
      }

      const playListCreatedId = await this.$store.dispatch('Medium/createPlaylist',
        {
          type: 'PlayList',
          name: this.playlistName,
          libraryFolderId: this.$store.state.Medium.selected_library_folder.id,
          test: this.$store.state.Medium.selected_library_folder.test
        })

      if (this.choice === 'PlayListLayout') {
        await Vue.axios.patch(`medium/${playListCreatedId}`, this.layoutData)
      }

      for (const child of children) {
        await this.$store.dispatch('Medium/assignMediumToPlaylist', [playListCreatedId, child.id])
        doneSoFarOperations++
        this.percentDone = parseInt(doneSoFarOperations / toBeDoneOperations * 100)
      }

      await this.$store.dispatch('Medium/assignMediumToPlaylist', [this.$store.state.Medium.selected_library_folder.id, playListCreatedId])
      this.$store.dispatch('Medium/clearBreadcrumbs')
      this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', playListCreatedId)
      this.$emit('loadEditMediumInMediaEditor', playListCreatedId)
      this.saving = false
      this.percentDone = 0
      this.$emit('linkerJobDone', 'create')
      this.playlistName = ''
    }
  },
  computed: {
    newPlayListHasName () {
      return this.playlistName.length > 0
    },
    newEmptyPlaylist () {
      return this.$store.state.Medium.media_selected_left.length === 0
    }
    // For future use.
    // Perhaps cannot mix test/non-test media? Test needed, using selections on media-list
    // newPlaylistLayoutHasMixedTestAttrMedia () {
    //   const values = [...new Set(children.map(ch => ch.test))]
    //   return values === 2
    // }
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
.form-item {
  display: flex;
  align-items: center;
  font-size: $--font-size-base;
  margin-bottom: 10px;
  .label {
    border: 0px solid green;
    width: 100px;
    text-align: right;
  }
  .suffix {
    margin-left: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogPlayListCreate.vue